import { jwtDecode } from 'jwt-decode'

export interface JwtPayload {
  exp: number
  iat: number
  roles?: string[]
  [key: string]: unknown
}

export function decodeJwtPayload(token?: string | null): JwtPayload | null {
  if (!token) {
    return null
  }

  try {
    return jwtDecode<JwtPayload>(token)
  } catch {
    return null
  }
}

export function isJwtPayloadValid(
  payload: JwtPayload | null | undefined,
  nowMs: number = Date.now()
): payload is JwtPayload {
  if (!payload) {
    return false
  }

  if (typeof payload.exp !== 'number') {
    return false
  }

  return payload.exp * 1000 > nowMs
}

/** BAT-1092: an athlete is a club account whose token carries
 *  `extra.participant_type = "ATHLETE"`. */
export function isAthletePayload(payload?: JwtPayload | null): boolean {
  const extra = payload?.extra as { participant_type?: unknown } | undefined
  return extra?.participant_type === 'ATHLETE'
}
